module.exports = __webpack_public_path__ + "img/gap-fill-2.cf7b5b40.png";